<script lang="ts">
	import type { TextEntity } from '@andresot/protocol';
	import { formattedSegments } from '$utils/textFormatting';
	let {
		text,
		entities = [],
		mentionOf
	}: { text: string; entities?: TextEntity[]; mentionOf?: (login: string) => boolean } = $props();
	let segments = $derived(formattedSegments(text, entities, mentionOf));
</script>

<p class="text">
	{#each segments as segment, index (index)}
		<span class:bold={segment.bold} class:italic={segment.italic}>
			{#if segment.kind === 'link'}
				<a
					href={segment.href}
					target="_blank"
					rel="noopener noreferrer"
					onclick={(event) => event.stopPropagation()}>{segment.text}</a
				>
			{:else if segment.kind === 'mention' && segment.active}
				<span class="mention">{segment.text}</span>
			{:else}{segment.text}{/if}
		</span>
	{/each}
</p>

<style>
	.text {
		margin: 0;
		white-space: pre-wrap;
		overflow-wrap: anywhere;
		font: var(--text-body);
	}
	.bold {
		font-weight: 700;
	}
	.italic {
		font-style: italic;
	}
	a,
	.mention {
		color: var(--accent-primary);
	}
	a {
		text-decoration: underline;
		text-underline-offset: 2px;
	}
	.mention {
		font-weight: 500;
	}
</style>
